import ModalElement from '../../../Common/ModalElement';

const CourierDetailsModal = ({ hideModal, courierDetails }) => {

    return (
        <ModalElement size="md" show={Object.keys(courierDetails || {}).length} title={"Courier Details"} onHide={hideModal}>
            <div className='text-start'>
                <div className="mb-3">
                    <p className="fw-medium text-muted p-2 mb-0" style={{ backgroundColor: "#f9f9f9"}}>Courier Name:</p>
                    <p className="px-2 mb-1">{courierDetails?.courier_name || 'N/A'}</p>
                </div>

                <div className="mb-3">
                    <p className="fw-medium text-muted p-2 mb-0" style={{ backgroundColor: "#f9f9f9"}}>Tracking/AWB No:</p>
                    <p className="px-2 mb-1 font-monospace">{courierDetails?.tracking_number || 'N/A'}</p>
                </div>

                <div className="mb-3">
                    <p className="fw-medium text-muted p-2 mb-0" style={{ backgroundColor: "#f9f9f9"}}>Dispatch Date:</p>
                    <p className="px-2 mb-1">{courierDetails?.dispatch_date || 'N/A'}</p>
                </div>

                <div className="mb-3">
                    <p className="fw-medium text-muted p-2 mb-0" style={{ backgroundColor: "#f9f9f9"}}>Contact Details:</p>
                    <p className="px-2 mb-1">{courierDetails?.contact_info || 'N/A'}</p>
                </div>

                <div>
                    <p className="fw-medium text-muted p-2 mb-0" style={{ backgroundColor: "#f9f9f9"}}>Remark:</p>
                    <p className="px-2 mb-0">{courierDetails?.remark || 'N/A'}</p>
                </div>
            </div>
        </ModalElement>
    );
};

export default CourierDetailsModal;